import React, { useEffect, useState } from 'react'
import { Box, Button, IconButton, Modal, Paper, Typography } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'

const BannerBusiness = (props) => {

  const [ isMobile, setIsMobile ] = useState(window.innerWidth <= 720);
  const [ isTablet, setIsTablet ] = useState(window.innerWidth <= 1164);
  const [ isModalVisible, setIsModalVisible ] = useState(false);


  // Use the useEffect hook to update the isMobile & isTabletd state when the window is resized
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 720); // Adjust the screen width threshold
      setIsTablet(window.innerWidth <= 1164); // Adjust the screen width threshold
    }

    window.addEventListener('resize', handleResize);

    // Clean up the event listener when the component unmounts
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const handleModalOpen = () => { setIsModalVisible(true)}
  const handleModalClose = () => { setIsModalVisible(false)}

  return (
    <Box sx={{display: "block", clear: "both",}}>
      <Box
        height="90vh"
        sx={{
          backgroundAttachment: "fixed",
          backgroundImage: 
            process.env.NODE_ENV === 'development' ?
            "url('/assets/webp/render-boardroom.webp')" : 
            "url('/wp-content/themes/personal-architect/assets/webp/render-boardroom.webp')"
          ,
          backgroundPositionX: "50%",
          backgroundPositionY: "50%",
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
          display: "flex",
          flexWrap: "wrap",
          justifyContent: "space-between",
        }}
        width="100%"
      >
        <Box
          sx={{
            display: "flex",
            height: "100%",
            justifyContent: "center",
            p:3,
          }}
        >
          <Box sx={{display: "flex", justifyContent:"center", flexDirection: "column", zIndex: 2,}}>
            <Box
              sx={{
                background: "linear-gradient(to right, rgba(0,0,0,0.75), transparent)",
                borderRadius: 1,
                p:2,
                mt: -15,
              }}
            >
              <Typography component="h1" color="#fff" fontSize={!isMobile ? 100 : 80} fontWeight={600} lineHeight={.8} variant="h1">
                Grow<br/>Your<br/>Business.
              </Typography>
              <Box sx={{my: 2, p:1,}}>
                <Typography color="#fff">Our experts can provide turnkey solutions</Typography>
                <Typography color="#fff">for product manufacturers, retailers, and software companies.</Typography>
              </Box>
              <Box>
                <Button fullWidth href="#contact-form" variant="contained" sx={{m:.25,}}>Contact Us</Button>
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
      <Box sx={{alignItems: "center", display: "flex", flex: 1, justifyContent: "flex-end", mt: !isTablet ? "-33.3%" : "-40%", overflow: "hidden", zIndex: 1,}}>
        <Box
          component="img"
          height="100%"
          src={
            process.env.NODE_ENV === 'development' ?
            "/assets/webp/product-multi-5.webp" : 
            "/wp-content/themes/personal-architect/assets/webp/product-multi-5.webp"
          }
          sx={{
            borderRadius: 1,
            maxWidth: 900,
            opacity: .95,
          }}
          width="100%"
        >
        </Box>
      </Box>
      <Modal
        open={isModalVisible}
        onClose={handleModalClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Paper sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            bgcolor: 'background.paper',
            boxShadow: 24,
            borderRadius: 2,
        }}>
          <Box sx={{alignItems: "center", display: "flex", justifyContent: "flex-end"}}>
            <IconButton onClick={handleModalClose}>
              <CloseIcon />
            </IconButton>
          </Box>
          <Box sx={{p: 1,}}>
            <iframe
              width="560"
              height="315"
              src="https://www.youtube.com/embed/ya3KeRFvPeE?si=o1mpLeSApsAhgouH"
              title="YouTube video player"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowfullscreen
              style={{borderRadius: "4px",}}
            ></iframe>
          </Box>
        </Paper>
      </Modal>
    </Box>
  )
}

export default BannerBusiness